import CustomerList from '../components/customer/List.vue';
import CustomerCreate from '../components/customer/Create.vue';
import CustomerUpdate from '../components/customer/Update.vue';
import CustomerShow from '../components/customer/Show.vue';

export default [
  { name: 'CustomerList', path: '/customers/', component: CustomerList },
  { name: 'CustomerCreate', path: '/customers/create', component: CustomerCreate },
  { name: 'CustomerUpdate', path: "/customers/edit/:id", component: CustomerUpdate },
  { name: 'CustomerShow', path: "/customers/show/:id", component: CustomerShow  }
];



// WEBPACK FOOTER //
// ./src/routes/customer.js